import { z } from "zod";

export const qlikMeasureSchema = z.object({
  id: z.string(),
  title: z.string(),
  description: z.string().optional(),
  expression: z.string().optional(),
  label: z.string().optional(),
  tags: z.array(z.string()),
  numberFormat: z.string().optional(),
  color: z.string().optional(),
});

export type QlikMeasure = z.infer<typeof qlikMeasureSchema>;

export const listQlikMeasuresResponseSchema = z.object({
  data: z.array(qlikMeasureSchema),
});

export type ListQlikMeasuresResponse = z.infer<typeof listQlikMeasuresResponseSchema>;

export const updateQlikMeasureInputSchema = z.object({
  title: z.string().min(1).optional(),
  description: z.string().optional(),
  expression: z.string().optional(),
  label: z.string().optional(),
  tags: z.array(z.string()).optional(),
  numberFormat: z.string().optional(),
  color: z.string().optional(),
});

export type UpdateQlikMeasureInput = z.infer<typeof updateQlikMeasureInputSchema>;
